// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-795699ce] {\n  margin-bottom: 10px;\n}\n.table-footer[data-v-795699ce] {\n  padding: 20px;\n  border: 1px #e4e4e4 solid;\n  background-color: #f9fafc;\n  line-height: 2;\n  font-size: 13px;\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
